<template>
  <div>
    <cessation-form
      :form-model="formModel"
      :required="required"
    ></cessation-form>
  </div>
</template>

<script>
import CessationForm from './forms/cessation-form.vue';
export default {
  components: { CessationForm },
  inject: ['$validator'],
  props: ['formModel', 'required'],
};
</script>
